<section class="dash-page">

  <!-- Hidden candidate-card whose `invite()` + `#jobsupplytemplate` back the
       Top Candidate Spotlight "Invite" button (Talent Pool tab). The unknown
       `viewSize` keeps every visual *ngIf branch false, so only the top-level
       `#jobsupplytemplate` registers via ViewChild — parity with the Bench
       Sales dashboard's hidden `<app-job-card>`. -->
  <app-candidate-card #spotlightCandidateCardRef
                      [viewSize]="'__spotlight_invite_only__'"
                      style="display:none"></app-candidate-card>

  <!-- Welcome -->
  <div class="welcome">
    <div class="welcome-left">
      <h1>{{greeting}}{{ userFirstName ? ', ' + userFirstName : '' }} 👋  </h1>
      <p>{{ todayFormatted }}<span class="welcome-sep">·</span>Here's what needs your attention today</p>
    </div>
    <div class="welcome-right">
      <button class="btn btn-outline" type="button" disabled><ng-icon name="tablerCalendar" class="gs-ico"></ng-icon> Schedule</button>
      <button class="btn btn-primary" type="button" (click)="onPostNewJob()"><ng-icon name="tablerPlus" class="gs-ico"></ng-icon> Post New Job</button>
    </div>
  </div>

  <!-- Quick actions bar -->
  <div class="quick-bar">
    <span class="quick-bar-label">Quick Actions</span>
    <button class="qb-btn qb-primary" type="button" (click)="onPostNewJob()"><ng-icon name="tablerPlus" class="gs-ico"></ng-icon> Post New Job</button>
    <button class="qb-btn" type="button" disabled><ng-icon name="tablerUser" class="gs-ico"></ng-icon> Add Candidate</button>
    <button class="qb-btn" type="button" disabled><ng-icon name="tablerCalendar" class="gs-ico"></ng-icon> Schedule Interview</button>
    <button class="qb-btn" type="button" disabled><ng-icon name="tablerFileText" class="gs-ico"></ng-icon> Send Offer</button>
    <button class="qb-btn" type="button" disabled><ng-icon name="tablerMessage" class="gs-ico"></ng-icon> Message Candidate</button>
    <span class="quick-bar-divider"></span>
    <button class="qb-btn" type="button" disabled><ng-icon name="tablerActivity" class="gs-ico"></ng-icon> View Reports</button>
    <span class="qb-search is-disabled" aria-disabled="true">
      <ng-icon name="tablerSearch" class="gs-ico"></ng-icon>
      <span>Search jobs, candidates…</span>
      <span class="qb-shortcut">⌘K</span>
    </span>
  </div>

  <!-- AI insight strip -->
  <div class="insights-strip">
    <div class="insight-card" [ngClass]="'insight-' + item.tone"
         *ngFor="let item of data.insights">
      <div class="insight-hdr">
        <span class="insight-icon" [ngClass]="'insight-icon-' + item.tone">
          <ng-icon *ngIf="item.tone==='red'"    name="tablerAlertCircle"   class="gs-ico gs-ico-xl"></ng-icon>
          <ng-icon *ngIf="item.tone==='amber'"  name="tablerActivity"      class="gs-ico gs-ico-xl"></ng-icon>
          <ng-icon *ngIf="item.tone==='green'"  name="tablerCheck"         class="gs-ico gs-ico-xl"></ng-icon>
          <ng-icon *ngIf="item.tone==='blue'"   name="tablerInfoCircle"    class="gs-ico gs-ico-xl"></ng-icon>
          <ng-icon *ngIf="item.tone==='purple'" name="tablerStar"          class="gs-ico gs-ico-xl"></ng-icon>
        </span>
        <span class="insight-tag" [ngClass]="'insight-tag-' + item.tone">{{ item.tag }}</span>
        <span class="insight-ai"><ng-icon name="tablerRobot" class="gs-ico"></ng-icon> Sumo AI</span>
      </div>
      <div class="insight-body" [innerHTML]="item.body"></div>
      <a class="insight-cta" href="javascript:void(0)">{{ item.cta }}</a>
    </div>
  </div>

  <!-- KPI stat grid -->
  <div class="stat-grid">
    <div class="stat-card" [ngClass]="'acc-' + kpi.accent" *ngFor="let kpi of data.kpis">
      <div class="s-icon" [ngClass]="'s-icon-' + kpi.accent">
        <gs-dash-icon [name]="kpi.iconName" class="gs-ico gs-ico-lg"></gs-dash-icon>
      </div>
      <div class="s-label">{{ kpi.label }}</div>
      <div class="s-value">{{ kpiOverrides[kpi.label] !== undefined ? kpiOverrides[kpi.label] : kpi.value }}<span class="s-unit" *ngIf="kpi.unit">{{ kpi.unit }}</span></div>
      <div class="s-sub">{{ kpi.sub }}</div>
      <!-- Live trend pill when the This Week Summary v1.0.252 fields
           `activeJobsStats` / `todayApplicants` are present on the
           response; otherwise falls back to the mock `kpi.trend`. -->
      <div class="s-trend" [ngClass]="'trend-' + (kpiTrendOverrides[kpi.label]?.dir || kpi.trend.dir)">
        <gs-dash-icon [name]="(kpiTrendOverrides[kpi.label]?.dir || kpi.trend.dir)==='up' ? 'tablerArrowUp' : (kpiTrendOverrides[kpi.label]?.dir || kpi.trend.dir)==='down' ? 'tablerArrowDown' : 'tablerArrowRight'"
                      class="gs-ico gs-ico-sm"></gs-dash-icon>
        {{ kpiTrendOverrides[kpi.label]?.text || kpi.trend.text }}
      </div>
    </div>
  </div>

  <!-- Row: Active Jobs + Top Candidate Spotlight — awaiting backend APIs (cards render empty) -->
  <div class="section-row row-2">
    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerBriefcase" class="gs-ico gs-ico-md"></ng-icon> Active Jobs</div>
        <a class="card-action" href="javascript:void(0)" (click)="goToActiveJobsList()">All jobs →</a>
      </div>
      <div class="list-scroll">
        <gs-skeleton-list *ngIf="loadingActiveJobs && !activeJobs.length" [rows]="5" variant="row"></gs-skeleton-list>
        <div class="job-row"
             *ngFor="let j of activeJobs"
             [class.selected]="j.id === selectedJobId"
             (click)="selectActiveJob(j)"
             role="button"
             tabindex="0"
             (keydown.enter)="selectActiveJob(j)">
          <div class="job-av" [style.background]="j.color">{{ j.initials }}</div>
          <div class="job-info">
            <div class="job-name" [title]="j.name">{{ j.name }}</div>
            <div class="job-meta" [title]="j.meta">{{ j.meta }}</div>
          </div>
          <!-- Counts go through `compactCount` so the three columns stay inside
               the `min-width` that keeps them aligned row to row (dashboard.scss
               :723). The exact figure stays on the `[title]`, same as the card
               footers do (job.component.html:353). -->
          <div class="job-stats">
            <div class="job-stat" [title]="j.applied + ' Applicants'"><span class="job-stat-val">{{ j.applied | compactCount }}</span><span class="job-stat-lbl">Applicants</span></div>
            <div class="job-stat" [title]="j.views + ' Views'"><span class="job-stat-val">{{ j.views | compactCount }}</span><span class="job-stat-lbl">Views</span></div>
            <div class="job-stat" [title]="j.liked + ' Liked'"><span class="job-stat-val">{{ j.liked | compactCount }}</span><span class="job-stat-lbl">Liked</span></div>
          </div>
          <span class="pill" [ngClass]="'pill-' + j.pill.tone">{{ j.pill.label }}</span>
        </div>
        <div class="dash-empty" *ngIf="!loadingActiveJobs && !activeJobs.length">No active jobs found</div>
      </div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <!-- `card-title-text` / `spotlight-card-title` keep this header on one
             line: the static label never wraps and the live job-title suffix
             truncates instead, so the card's divider stays level with the
             Active Jobs card beside it. -->
        <div class="card-title spotlight-card-title">
          <ng-icon name="tablerStar" class="gs-ico gs-ico-md"></ng-icon>
          <span class="card-title-text">Top Candidate Spotlight</span>
          <span class="spotlight-job-ctx" *ngIf="selectedJobTitle" [title]="selectedJobTitle"> · {{ selectedJobTitle }}</span>
        </div>
        <a class="card-action" href="javascript:void(0)"
           [class.disabled]="!selectedJobId"
           (click)="goToSpotlightTab()">View all →</a>
      </div>
      <div class="spotlight-tabs">
        <button class="sp-tab"
                *ngFor="let t of data.spotlightTabs"
                [class.active]="activeSpotlightTab === t.id"
                (click)="selectSpotlight(t.id)"
                type="button">
          {{ t.label }}
          <span class="sp-tab-count" [title]="spotlightTabCount(t.id)">{{ spotlightTabCount(t.id) | compactCount }}</span>
        </button>
      </div>

      <div class="list-scroll">
        <gs-skeleton-list *ngIf="spotlightLoading && !spotlightRows.length" [rows]="4" variant="row"></gs-skeleton-list>

        <div class="spotlight-row" *ngFor="let c of spotlightRows">
          <div class="spotlight-rank">{{ c.rank }}</div>
          <div class="spotlight-av" [style.background]="c.color">{{ c.initials }}</div>
          <div class="spotlight-info">
            <div class="spotlight-name" [title]="c.name">{{ c.name }}</div>
            <div class="spotlight-job" [title]="c.job">{{ c.job }}</div>
            <div class="spotlight-meta" [title]="c.meta">{{ c.meta }}</div>
          </div>
          <div class="match-badge" [ngClass]="'mb-' + c.tone"
               style="cursor:context-menu;"
               (click)="$event.stopPropagation()">
            <span class="match-pct">{{ c.match != null ? c.match + '%' : '-' }}</span>
            <span class="match-lbl">{{ c.match != null && c.match < 80 ? 'Match' : 'Match' }}</span>
          </div>
          <button class="btn btn-primary" type="button"
                  [disabled]="selectedJobStatus === 'BLOCKED'"
                  [title]="selectedJobStatus === 'BLOCKED' ? 'Job is blocked' : ''"
                  (click)="onSpotlightInvite(c)">{{ c.action }}</button>
        </div>

        <div class="dash-empty" *ngIf="!selectedJobId && !spotlightLoading">
          Select a job from the left to view candidates
        </div>
        <div class="dash-empty" *ngIf="selectedJobId && !spotlightLoading && !spotlightRows.length">
          No candidates found
        </div>
      </div>

      <!-- Sumo AI Recommendation -->
      <div class="sumo-ai-block" *ngIf="data.sumoRec?.body">
        <div class="sumo-ai-hdr">
          <div class="sumo-ai-icon"><ng-icon name="tablerRobot" class="gs-ico gs-ico-md"></ng-icon></div>
          <div class="sumo-ai-title">Sumo AI Recommendation</div>
          <span class="sumo-ai-badge">AI</span>
        </div>
        <div class="sumo-ai-body" [innerHTML]="data.sumoRec.body"></div>
        <div class="sumo-ai-actions">
          <button class="btn btn-primary" type="button" disabled><ng-icon name="tablerSend" class="gs-ico"></ng-icon> Invite Sunita Rao</button>
          <button class="btn btn-outline" type="button" disabled><ng-icon name="tablerBriefcase" class="gs-ico"></ng-icon> Post to Marketplace</button>
          <button class="btn btn-outline" type="button" disabled style="margin-left:auto;">Dismiss</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Row: Interviews Today + Today's Activity + Weekly metrics (Interviews Today awaits backend API) -->
  <div class="section-row row-3">
    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerCalendar" class="gs-ico gs-ico-md"></ng-icon> Interviews Today</div>
        <span class="pill pill-gray">0 today</span>
      </div>
      <div class="interview-item" *ngFor="let iv of data.interviewsToday">
        <div class="iv-time-block">
          <!-- <div class="iv-time">{{ iv.time }}</div> -->
           <div class="iv-time">{{ iv.time | timezoneDate:'h:mm a' }}</div>
          <div class="iv-ampm">{{ iv.ampm }}</div>
        </div>
        <div class="iv-divider"></div>
        <div class="iv-info">
          <div class="iv-name" [title]="iv.name">{{ iv.name }}</div>
          <div class="iv-role" [title]="iv.role">{{ iv.role }}</div>
          <div class="iv-company" [title]="iv.company">{{ iv.company }}</div>
        </div>
        <div class="iv-status">
          <span class="pill" [ngClass]="'pill-' + iv.tone">{{ iv.status }}</span>
          <span class="iv-type">
            <gs-dash-icon
              [name]="iv.type === 'Phone' ? 'tablerPhone' : (iv.type === 'On-site' || iv.type === 'Onsite' || iv.type === 'In-person') ? 'tablerHome' : 'tablerVideo'"
              class="gs-ico gs-ico-sm"></gs-dash-icon>
            {{ iv.type }}
          </span>
        </div>
      </div>
      <div class="dash-empty" *ngIf="!data.interviewsToday?.length">No interviews today</div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerClock" class="gs-ico gs-ico-md"></ng-icon> Today's Activity</div>
        <span class="pill pill-gray">
          {{ (todayActivity.length ? todayActivity : data.todayActivity).length }} events
        </span>
      </div>
      <gs-skeleton-list *ngIf="loadingTodayActivity && !todayActivity.length" [rows]="5" variant="activity"></gs-skeleton-list>
      <div class="activity-list list-scroll">
        <div class="activity-item" *ngFor="let a of (todayActivity.length ? todayActivity : data.todayActivity)">
          <span class="act-dot" [style.background]="
            a.tone==='green' ? 'var(--gs-green)' :
            a.tone==='amber' ? 'var(--gs-amber)' :
            a.tone==='red'   ? 'var(--gs-red)' :
            a.tone==='blue'  ? 'var(--gs-blue)' : 'var(--gs-purple-light)'">
          </span>
          <div class="act-text" [innerHTML]="a.text"></div>
          <!-- View-summary rows carry a literal label (e.g. "Yesterday", timeIsLabel:true);
               event rows carry an epoch time that gets formatted. Piping the literal
               through timezoneDate would blank it out (unparseable), so branch. -->
              <span class="act-time">{{ a.timeIsLabel ? a.time : (a.time | timezoneDate:'h:mm a') }}</span>
        </div>
      </div>
      <div class="dash-empty" *ngIf="!loadingTodayActivity && !todayActivity.length && !data.todayActivity?.length">
        No activity today
      </div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerActivity" class="gs-ico gs-ico-md"></ng-icon> Weekly Activity Metrics</div>
        <span class="card-action">{{ weeklyMetrics?.range }}</span>
      </div>
      <div class="dash-loading" *ngIf="loadingWeekly && !weeklyMetrics">Loading…</div>
      <div class="goal-item" *ngFor="let g of weeklyMetrics?.goals">
        <div class="goal-hdr">
          <span class="goal-name">{{ g.name }}</span>
          <span class="goal-nums"><strong>{{ g.current }}</strong> / {{ g.target }}</span>
        </div>
        <div class="goal-track">
          <div class="goal-fill"
               [style.width]="(g.target ? (g.current / g.target) * 100 : 0) + '%'"
               [style.background]="g.fill"></div>
        </div>
      </div>
      <div class="dash-empty" *ngIf="!loadingWeekly && (!weeklyMetrics || weeklyMetrics.goals.length === 0)">
        No metrics for this week.
      </div>
    </div>
  </div>

  <!-- Row: Hiring Pipeline + Offer Pipeline Tracker -->
  <div class="section-row row-2">
    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerFilter" class="gs-ico gs-ico-md"></ng-icon> Hiring Pipeline</div>
        <a class="card-action" href="javascript:void(0)" (click)="goToAllJobs()">View all →</a>
      </div>
      <div class="card-body">
        <div class="funnel">
          <div class="funnel-row" *ngFor="let s of (pipelineRows || data.pipeline)">
            <span class="funnel-lbl">{{ s.label }}</span>
            <div class="funnel-bar-wrap">
              <div class="funnel-bar"
                   [style.width]="s.pct + '%'"
                   [style.background]="s.color"
                   [style.color]="s.text">
                <span [title]="s.num">{{ s.num | compactCount }}</span>
              </div>
            </div>
            <span class="funnel-num" [title]="s.num">{{ s.num | compactCount }}</span>
          </div>
        </div>
        <div class="dash-empty" *ngIf="!(pipelineRows || data.pipeline)?.length">
          No pipeline data found
        </div>

        <div style="margin-top:20px;">
          <div class="s-label" style="margin-bottom:10px;">Applicants This Week</div>
          <div class="mini-chart">
            <div class="mc-bar"
                 *ngFor="let b of (applicantsThisWeekRows || data.applicantsThisWeek)"
                 [class.active]="b.active"
                 [class.sunday-gray]="b.day === 'Sun' && !b.active"
                 [style.height.%]="applicantBarHeight(b.val)">
              <span class="mc-tooltip">{{ b.val }} applicants</span>
            </div>
          </div>
          <div class="mc-labels">
            <span class="mc-lbl" *ngFor="let b of (applicantsThisWeekRows || data.applicantsThisWeek)">{{ b.day }}</span>
          </div>
          <div class="dash-empty" *ngIf="!hasApplicantsThisWeek">
            No applicants this week
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <div class="card-title"><ng-icon name="tablerFileText" class="gs-ico gs-ico-md"></ng-icon> Offer Pipeline Tracker</div>
        <!-- "{n} awaiting response" pill + "View all →" — parity with the
             Bench Sales dashboard's same card (bench-sales-dashboard.component.html:362-365)
             and the gigsumo_unified wireframe (line 1838). `offerStages[1]`
             is the Pending bucket; the pill hides when zero so the
             header isn't cluttered for healthy pipelines. -->
        <div style="display:flex;align-items:center;gap:8px;">
          <span class="pill pill-amber" *ngIf="offerStages[1]?.val">{{ offerStages[1].val }} awaiting response</span>
          <button class="card-action" type="button" (click)="goToAllJobs()">View all →</button>
        </div>
      </div>
      <div class="offer-track-grid" *ngIf="offerStages.length">
        <div class="offer-stage-cell" [ngClass]="s.cls" *ngFor="let s of offerStages">
          <div class="osc-label">{{ s.label }}</div>
          <div class="osc-value">{{ s.val }}</div>
          <div class="osc-sub">{{ s.sub }}</div>
        </div>
      </div>
      <div class="list-scroll">
        <gs-skeleton-list *ngIf="loadingOffers && !offers.length" [rows]="5" variant="row"></gs-skeleton-list>
        <div class="offer-row" *ngFor="let o of offers">
          <div class="offer-av" *ngIf="o.photoUrl">
            <img [src]="o.photoUrl" alt="avatar" (error)="$any($event.target).style.display='none'">
          </div>
          <div class="offer-av" *ngIf="!o.photoUrl"
            [style.background]="getAvatarColor(o.name)"
            [style.color]="getAvatarTextColor(o.name)">{{ o.initials }}</div>
          <div class="offer-info">
            <div class="offer-name" [title]="o.name">{{ o.name }}</div>
            <div class="offer-role" [title]="o.role">{{ o.role }}</div>
            <div class="offer-company" [title]="o.company">{{ o.company }}</div>
          </div>
          <div class="offer-right">
            <div class="offer-amount">{{ o.amount }}</div>
            <span class="pill" [ngClass]="'pill-' + o.tone">
              <gs-dash-icon [name]="o.statusIcon" class="gs-ico gs-ico-sm"></gs-dash-icon> {{ o.statusText }}
            </span>
            <span class="offer-deadline" *ngIf="o.deadline">{{ o.deadline }}</span>
          </div>
        </div>
        <div class="dash-empty" *ngIf="!loadingOffers && offers.length === 0">
          No offers yet.
        </div>
      </div>
    </div>
  </div>

  <!-- Row: Slots + This Week -->
  <div class="section-row row-2">
    <div class="card">
      <div class="card-hdr">
        <!-- Eyebrow-style header per gigsumo_unified(48).html mock
             (line 1861): small uppercase gray label + plan pill, no
             inline icon. -->
        <div class="card-title slot-eyebrow">Job & Candidate Slots</div>
        <span class="pill pill-purple" *ngIf="slots.plan">{{ slots.plan }}</span>
      </div>
      <div class="donut-wrap">
        <!-- SVG ring donut with 2-line center label ("N/M" + "USED").
             Replaces the old CSS conic-gradient pie so the widget reads
             as a donut (open hole) rather than a filled pie. -->
        <div class="donut-svg-wrap">
          <svg viewBox="0 0 64 64" class="donut-svg" aria-hidden="true">
            <circle class="donut-ring-bg" cx="32" cy="32" r="25"/>
            <circle class="donut-ring-used" cx="32" cy="32" r="25"
                    [attr.stroke-dashoffset]="donutDashoffset()"/>
          </svg>
          <div class="donut-center">
            <div class="donut-val">{{ slots.used }}/{{ slots.allocated }}</div>
            <div class="donut-sub">Used</div>
          </div>
        </div>
        <div class="donut-legend">
          <!-- Legend dot colors match the mock: purple-light for used,
               #DDD6FE for open, gray-200 for allocated. Open value is
               green per mock so users notice "still-available" capacity. -->
          <div class="dl-item">
            <span class="dl-dot" style="background:var(--gs-purple-light)"></span>
            Slots Used <span class="dl-val">{{ slots.used }}</span>
          </div>
          <div class="dl-item">
            <span class="dl-dot" style="background:#DDD6FE"></span>
            Slots Open <span class="dl-val open-val">{{ slots.open }}</span>
          </div>
          <div class="dl-item">
            <span class="dl-dot" style="background:var(--gs-gray-200)"></span>
            Allocated <span class="dl-val">{{ slots.allocated }}</span>
          </div>
        </div>
      </div>
      <div class="slots-grid">
        <div class="slots-cell">
          <div class="slots-val">{{ slots.allocated }}</div>
          <div class="slots-lbl">Allocated</div>
        </div>
        <div class="slots-cell">
          <div class="slots-val">{{ slots.used }}</div>
          <div class="slots-lbl">Used</div>
        </div>
        <div class="slots-cell">
          <div class="slots-val green">{{ slots.open }}</div>
          <div class="slots-lbl">Open</div>
        </div>
        <div class="slots-cell">
          <div class="slots-val blue">{{ slots.totalPosted }}</div>
          <div class="slots-lbl">Total Posted</div>
        </div>
      </div>
      <div class="slots-cta" role="button" tabindex="0"
           (click)="goToPlanQuota()"
           (keydown.enter)="goToPlanQuota()"
           (keydown.space)="goToPlanQuota()">
        <!-- Filled purple icon tile per mock (gigsumo_unified(48).html:
             871-872). Keeps the upgrade CTA visually distinct from a
             plain icon-row and matches the other dashboard. -->
        <span class="slots-cta-icon">
          <ng-icon name="tablerTrendingUp" class="gs-ico"></ng-icon>
        </span>
        <div style="flex:1">
          <div><strong>Need more slots?</strong></div>
          <div style="font-size:11px;color:var(--gs-gray-500);">Upgrade to Pro — unlimited slots</div>
        </div>
        <ng-icon name="tablerArrowRight" class="gs-ico gs-ico-md"></ng-icon>
      </div>
    </div>

    <div class="card">
      <div class="card-hdr">
        <div class="card-title">This Week</div>
        <span class="card-action">{{ thisWeek.range }}</span>
      </div>
      <div class="tw-row" *ngFor="let r of thisWeek.rows">
        <span class="tw-label">
          <span class="tw-dot" [style.background]="r.color"></span>
          {{ r.label }}
        </span>
        <span>
          <span class="tw-val">{{ r.val }}</span>
          <span class="tw-delta" [ngClass]="r.delta.dir">
            <gs-dash-icon [name]="r.delta.dir==='up' ? 'tablerArrowUp' : r.delta.dir==='down' ? 'tablerArrowDown' : 'tablerArrowRight'"
                          class="gs-ico gs-ico-sm"></gs-dash-icon>
            {{ r.delta.text }}
          </span>
        </span>
      </div>
    </div>
  </div>

</section>
